<template>
  <div>
    <p class="cm-mg-p-wzd">
      3.1 {{ $t('devices.station_association_companies_farms') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }}: *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.business_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`${option.name}-${option.id}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_one_or_many_farms') }}:</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.farm_ids', farms)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.farm_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in farms"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`${option.name}-${option.id}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('devices.select_one_or_many_sensors') }}:</label
          >
          <br />
          <el-select
            collapse-tags
            @change="
              selectAllFromSelect('model.associated_sensors', getSensorList)
            "
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.associated_sensors"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in getSensorList"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('devices.select_one_or_many_calculated') }}:</label
          >
          <br />
          <el-select
            collapse-tags
            @change="
              selectAllFromSelect(
                'model.calculated_sensors',
                getCalculatedSensors
              )
            "
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.calculated_sensors"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in getCalculatedSensors"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';
import MixinAlert from 'src/mixins/mixin-alert';

export default {
  data() {
    return {
      model: {
        business_ids: null,
        farm_ids: null,
        sensor_ids: null,
        associated_sensors: [],
        calculated_sensors: [],
      },
      businesses: [],
      farms: [],
      sensors: [],
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinAlert],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },
  computed: {
    getSensorList() {
      return this.concatAll(
        this.sensors.filter((sensor) => Number(sensor.calculated) === 0)
      );
    },
    getCalculatedSensors() {
      return this.concatAll(
        this.sensors.filter((sensor) => Number(sensor.calculated) === 1)
      );
    },
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.farms = this.concatAll(this.farms.splice(1));
      this.sensors = this.concatAll(this.sensors.splice(1));
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, { ...this.model });
          this.$emit('fillStationForm', 'thirdStep', {
            sensor_ids: this.model.associated_sensors.concat(
              this.model.calculated_sensors
            ),
            names_business: this.businesses
              .filter((item) =>
                this.model.business_ids.some((element) => element == item.id)
              )
              .map((item) => item.name),
            names_farms: this.farms
              .filter((item) =>
                this.model.farm_ids.some((element) => element == item.id)
              )
              .map((item) => item.name),
            namesSensors: this.sensors
              .filter((item) =>
                this.model.associated_sensors.some(
                  (element) => element == item.id
                )
              )
              .map((item) => item.name),
            namesCalculatedSensors: this.sensors
              .filter((item) =>
                this.model.calculated_sensors.some(
                  (element) => element == item.id
                )
              )
              .map((item) => item.name),
          });

          return res;
        })
        .then((resp) => {
          if (!resp) return false;

          if (this.model.business_ids.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }

            return false;
          } else return true;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('businesses'),
        Axios.getMasters('farms/farms/'),
        Axios.getMasters('devices/sensors'),
      ])
        .then((response) => {
          const [responseBusiness, responseFarms, responseSensors] = response;
          this.businesses = this.concatAll(responseBusiness.data.data);
          this.farms = this.concatAll(responseFarms.data.data);
          this.sensors = this.concatAll(responseSensors.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.business_ids = this.selectElementsAsignFromModel(
              1,
              this.model.business_ids,
              this.businesses
            );

            if (
              this.model.business_ids === null &&
              this.businesses.length == 1
            ) {
              this.model.business_ids.push(this.businesses[0].id);
            }

            if (this.farms.length == 1)
              this.model.farm_ids.push(this.farms[0].id);

            const list = this.getSensorList;
            if (list.length == 1)
              this.model.associated_sensors.push(list[0].id);

            const calculateds = this.getCalculatedSensors;
            if (calculateds.length == 1)
              this.model.calculated_sensors.push(calculateds[0].id);
          } else {
            const { business_ids, farm_ids, sensor_ids, calculated_id } =
              JSON.parse(sessionStorage.getItem('editForm'));
            this.model = {
              ...this.model,
              business_ids,
              farm_ids,
              associated_sensors: sensor_ids,
              calculated_sensors: calculated_id,
            };
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else this.showHideLoading();
  },
};
</script>
<style></style>
